

























































































































































import { Component, Mixins, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import WhiteLabelModule from '@/store/modules/WhiteLabel';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';

@Component
export default class PasswordView extends Mixins(ErrorHandleMixin) {
  WhiteLabelInstance = getModule(WhiteLabelModule, this.$store);

  data = {
    color: {
      // primary: '#0d8c67',
      // secondary: '#e7dc4e',
      // primaryFont: '#333',
      // secondaryFont: '#fff',
      // thirdFont: '#5c676d',
      // primaryBackground: '#f2f3f4',
      // secondaryBackground: '#fff',
    },
    logo: {
      // path: '',
      // text: '',
      // width: '',
      // height: '',
    },
  }

  async mounted() {
    const data = await this.WhiteLabelInstance.FetchSettingImage();
    this.data = data.agentTheme;
  }

  @Watch('data', { immediate: true, deep: true })
  onChangeReport(val) {
    Object.keys(val).forEach((item) => {
      document.body.style.setProperty(`--${item}`, val[item]);
    });
  }

  async submit() {
    const theme = {
      agentTheme: this.data,
    };
    const res = await this.WhiteLabelInstance.EditSettingTheme(theme);
    this.checkError(res.status);
  }
}
